import { render, staticRenderFns } from "./Jmxx2.vue?vue&type=template&id=98766f30&scoped=true&"
import script from "./Jmxx2.vue?vue&type=script&lang=js&"
export * from "./Jmxx2.vue?vue&type=script&lang=js&"
import style0 from "./Jmxx2.vue?vue&type=style&index=0&id=98766f30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98766f30",
  null
  
)

export default component.exports